import type { Address } from '@/modules/address/domain/Address';

import type { CustomerRepository } from '../domain/CustomerRepository';

export const updateAddress = (
  repository: CustomerRepository,
  address: Address
) => {
  return repository.updateAddress(address);
};
